import React from 'react'

const GalleryItem = ({height, src, ...props}) => {
  return (
    <div
      style={{width: '100%', height: height ? height : '100px', backgroundImage: `url('${src}')`}}
      className="bg-no-repeat bg-center bg-cover rounded cursor-pointer"
      {...props}
    />
  )
}

export { GalleryItem }